module.exports = __webpack_public_path__ + "static/media/minerals.6a8a9d7d.png";